import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { anonRecord_type, class_type, list_type, option_type, int32_type, union_type, record_type, string_type, bool_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { empty, ofArray, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { logi } from "../../Utils.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { SaveStatus$reflection, LoadState$2$reflection } from "../../Global.js";

export class ValidateIcc extends Record {
    constructor(IsSuccess, Message) {
        super();
        this.IsSuccess = IsSuccess;
        this.Message = Message;
    }
}

export function ValidateIcc$reflection() {
    return record_type("Containers.SimpleOrder.Model.ValidateIcc", [], ValidateIcc, () => [["IsSuccess", bool_type], ["Message", string_type]]);
}

export class Service extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Mobile", "Data", "Topup", "Barring", "RoamingLimit", "CommonService", "ExtraSim", "Datapool", "CallForwarding", "DataFree", "FairUsage", "Unknown"];
    }
}

export function Service$reflection() {
    return union_type("Containers.SimpleOrder.Model.Service", [], Service, () => [[], [], [], [], [], [], [], [], [], [], [], [["Item", string_type]]]);
}

export function ServiceModule_ofString(_arg) {
    switch (_arg) {
        case "Mobile": {
            return new Service(0);
        }
        case "Data": {
            return new Service(1);
        }
        case "Topup": {
            return new Service(2);
        }
        case "Barring": {
            return new Service(3);
        }
        case "RoamingLimit": {
            return new Service(4);
        }
        case "CommonService": {
            return new Service(5);
        }
        case "ExtraSim": {
            return new Service(6);
        }
        case "Datapool": {
            return new Service(7);
        }
        case "CallForwarding": {
            return new Service(8);
        }
        case "DataFree": {
            return new Service(9);
        }
        case "FairUsage": {
            return new Service(10);
        }
        default: {
            return new Service(11, _arg);
        }
    }
}

export class NetworkContract extends Record {
    constructor(ContractName, IntegrationName, NetworkContractNr, NetworkIntegrationNr) {
        super();
        this.ContractName = ContractName;
        this.IntegrationName = IntegrationName;
        this.NetworkContractNr = (NetworkContractNr | 0);
        this.NetworkIntegrationNr = NetworkIntegrationNr;
    }
}

export function NetworkContract$reflection() {
    return record_type("Containers.SimpleOrder.Model.NetworkContract", [], NetworkContract, () => [["ContractName", string_type], ["IntegrationName", string_type], ["NetworkContractNr", int32_type], ["NetworkIntegrationNr", option_type(int32_type)]]);
}

export class ServiceCall extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["LoadNumberState", "TopupLoadPackages", "TopupLoadUsage", "DataPackageLoadCurrentPackage", "DataPackageLoadUsage", "BarringLoadStatus"];
    }
}

export function ServiceCall$reflection() {
    return union_type("Containers.SimpleOrder.Model.ServiceCall", [], ServiceCall, () => [[], [], [], [], [], []]);
}

export class ProviderServicesDTO extends Record {
    constructor(Implements, NetworkContract) {
        super();
        this.Implements = Implements;
        this.NetworkContract = NetworkContract;
    }
}

export function ProviderServicesDTO$reflection() {
    return record_type("Containers.SimpleOrder.Model.ProviderServicesDTO", [], ProviderServicesDTO, () => [["Implements", list_type(string_type)], ["NetworkContract", NetworkContract$reflection()]]);
}

export class ProviderServices extends Record {
    constructor(Implements, NetworkContract) {
        super();
        this.Implements = Implements;
        this.NetworkContract = NetworkContract;
    }
}

export function ProviderServices$reflection() {
    return record_type("Containers.SimpleOrder.Model.ProviderServices", [], ProviderServices, () => [["Implements", list_type(Service$reflection())], ["NetworkContract", NetworkContract$reflection()]]);
}

export function ProviderServices_OfDto_Z4FEEBB20(dto) {
    return new ProviderServices(map(ServiceModule_ofString, dto.Implements), dto.NetworkContract);
}

export function ProviderServices_GetServiceKind_50594B0D(service) {
    switch (service.tag) {
        case 1: {
            return ofArray([new ServiceCall(0), new ServiceCall(3), new ServiceCall(4)]);
        }
        case 3: {
            return ofArray([new ServiceCall(0), new ServiceCall(5)]);
        }
        case 0:
        case 4:
        case 5:
        case 6:
        case 9:
        case 8:
        case 10:
        case 7: {
            return empty();
        }
        case 11: {
            logi(toText(printf("Unrecognised Provider Service: %s"))(service.fields[0]));
            return empty();
        }
        default: {
            return ofArray([new ServiceCall(0), new ServiceCall(1), new ServiceCall(2)]);
        }
    }
}

export class TopupUsage extends Record {
    constructor(LimitBytes, RemainingBytes, StatusDate) {
        super();
        this.LimitBytes = LimitBytes;
        this.RemainingBytes = RemainingBytes;
        this.StatusDate = StatusDate;
    }
}

export function TopupUsage$reflection() {
    return record_type("Containers.SimpleOrder.Model.TopupUsage", [], TopupUsage, () => [["LimitBytes", option_type(class_type("System.Int64"))], ["RemainingBytes", option_type(class_type("System.Int64"))], ["StatusDate", string_type]]);
}

export class TopupPackage extends Record {
    constructor(Description, Id, Name, SizeInBytes, ValidUntil) {
        super();
        this.Description = Description;
        this.Id = Id;
        this.Name = Name;
        this.SizeInBytes = SizeInBytes;
        this.ValidUntil = ValidUntil;
    }
}

export function TopupPackage$reflection() {
    return record_type("Containers.SimpleOrder.Model.TopupPackage", [], TopupPackage, () => [["Description", string_type], ["Id", string_type], ["Name", string_type], ["SizeInBytes", option_type(class_type("System.Int64"))], ["ValidUntil", string_type]]);
}

export class TopupViewModel extends Record {
    constructor(Usage, Packages, SelectedPackage, PackageSaveStatus) {
        super();
        this.Usage = Usage;
        this.Packages = Packages;
        this.SelectedPackage = SelectedPackage;
        this.PackageSaveStatus = PackageSaveStatus;
    }
}

export function TopupViewModel$reflection() {
    return record_type("Containers.SimpleOrder.Model.TopupViewModel", [], TopupViewModel, () => [["Usage", LoadState$2$reflection(TopupUsage$reflection(), string_type)], ["Packages", LoadState$2$reflection(list_type(TopupPackage$reflection()), string_type)], ["SelectedPackage", string_type], ["PackageSaveStatus", SaveStatus$reflection()]]);
}

export class DataPackage extends Record {
    constructor(Description, Id, Name, SizeInBytes) {
        super();
        this.Description = Description;
        this.Id = Id;
        this.Name = Name;
        this.SizeInBytes = SizeInBytes;
    }
}

export function DataPackage$reflection() {
    return record_type("Containers.SimpleOrder.Model.DataPackage", [], DataPackage, () => [["Description", string_type], ["Id", string_type], ["Name", string_type], ["SizeInBytes", option_type(class_type("System.Int64"))]]);
}

export class DataPackageUsage extends Record {
    constructor(ExtraData, LimitBytes, RemainingBytes, RoamingBytes, RolloverBytes, StatusDate) {
        super();
        this.ExtraData = ExtraData;
        this.LimitBytes = LimitBytes;
        this.RemainingBytes = RemainingBytes;
        this.RoamingBytes = RoamingBytes;
        this.RolloverBytes = RolloverBytes;
        this.StatusDate = StatusDate;
    }
}

export function DataPackageUsage$reflection() {
    return record_type("Containers.SimpleOrder.Model.DataPackageUsage", [], DataPackageUsage, () => [["ExtraData", list_type(anonRecord_type(["Key", string_type], ["Value", string_type]))], ["LimitBytes", option_type(class_type("System.Int64"))], ["RemainingBytes", option_type(class_type("System.Int64"))], ["RoamingBytes", option_type(class_type("System.Int64"))], ["RolloverBytes", option_type(class_type("System.Int64"))], ["StatusDate", string_type]]);
}

export class DataPackageViewModel extends Record {
    constructor(CurrentPackage, Usage, Packages, SelectedPackage, PackageSaveStatus) {
        super();
        this.CurrentPackage = CurrentPackage;
        this.Usage = Usage;
        this.Packages = Packages;
        this.SelectedPackage = SelectedPackage;
        this.PackageSaveStatus = PackageSaveStatus;
    }
}

export function DataPackageViewModel$reflection() {
    return record_type("Containers.SimpleOrder.Model.DataPackageViewModel", [], DataPackageViewModel, () => [["CurrentPackage", LoadState$2$reflection(option_type(DataPackage$reflection()), string_type)], ["Usage", LoadState$2$reflection(DataPackageUsage$reflection(), string_type)], ["Packages", LoadState$2$reflection(list_type(DataPackage$reflection()), string_type)], ["SelectedPackage", string_type], ["PackageSaveStatus", SaveStatus$reflection()]]);
}

export class BarringStatus extends Record {
    constructor(InternationalOut, Locked, Outgoing, Premium, Roaming, Topup, TopupEnabled) {
        super();
        this.InternationalOut = InternationalOut;
        this.Locked = Locked;
        this.Outgoing = Outgoing;
        this.Premium = Premium;
        this.Roaming = Roaming;
        this.Topup = Topup;
        this.TopupEnabled = TopupEnabled;
    }
}

export function BarringStatus$reflection() {
    return record_type("Containers.SimpleOrder.Model.BarringStatus", [], BarringStatus, () => [["InternationalOut", option_type(bool_type)], ["Locked", option_type(bool_type)], ["Outgoing", option_type(bool_type)], ["Premium", option_type(bool_type)], ["Roaming", option_type(bool_type)], ["Topup", option_type(bool_type)], ["TopupEnabled", bool_type]]);
}

export class BarringViewModel extends Record {
    constructor(IsEditing, ServerValues, UserValues, SaveStatus) {
        super();
        this.IsEditing = IsEditing;
        this.ServerValues = ServerValues;
        this.UserValues = UserValues;
        this.SaveStatus = SaveStatus;
    }
}

export function BarringViewModel$reflection() {
    return record_type("Containers.SimpleOrder.Model.BarringViewModel", [], BarringViewModel, () => [["IsEditing", bool_type], ["ServerValues", LoadState$2$reflection(BarringStatus$reflection(), string_type)], ["UserValues", BarringStatus$reflection()], ["SaveStatus", SaveStatus$reflection()]]);
}

export class CommonServiceState extends Record {
    constructor(Voicemail, Data, DatapackageInMb, Mms) {
        super();
        this.Voicemail = Voicemail;
        this.Data = Data;
        this.DatapackageInMb = DatapackageInMb;
        this.Mms = Mms;
    }
}

export function CommonServiceState$reflection() {
    return record_type("Containers.SimpleOrder.Model.CommonServiceState", [], CommonServiceState, () => [["Voicemail", option_type(bool_type)], ["Data", option_type(bool_type)], ["DatapackageInMb", option_type(int32_type)], ["Mms", option_type(bool_type)]]);
}

export class RoamingState extends Record {
    constructor(Enabled, NumericLimit) {
        super();
        this.Enabled = Enabled;
        this.NumericLimit = NumericLimit;
    }
}

export function RoamingState$reflection() {
    return record_type("Containers.SimpleOrder.Model.RoamingState", [], RoamingState, () => [["Enabled", option_type(bool_type)], ["NumericLimit", option_type(int32_type)]]);
}

export class GeneralState extends Record {
    constructor(ReadOnlyNumber, ReadOnlyIcc, ReadOnlyImsi) {
        super();
        this.ReadOnlyNumber = ReadOnlyNumber;
        this.ReadOnlyIcc = ReadOnlyIcc;
        this.ReadOnlyImsi = ReadOnlyImsi;
    }
}

export function GeneralState$reflection() {
    return record_type("Containers.SimpleOrder.Model.GeneralState", [], GeneralState, () => [["ReadOnlyNumber", option_type(string_type)], ["ReadOnlyIcc", option_type(string_type)], ["ReadOnlyImsi", option_type(string_type)]]);
}

export class BarringStatusDTO1 extends Record {
    constructor(Locked, Outgoing, Roaming, Premium, InternationalOut) {
        super();
        this.Locked = Locked;
        this.Outgoing = Outgoing;
        this.Roaming = Roaming;
        this.Premium = Premium;
        this.InternationalOut = InternationalOut;
    }
}

export function BarringStatusDTO1$reflection() {
    return record_type("Containers.SimpleOrder.Model.BarringStatusDTO1", [], BarringStatusDTO1, () => [["Locked", option_type(bool_type)], ["Outgoing", option_type(bool_type)], ["Roaming", option_type(bool_type)], ["Premium", option_type(bool_type)], ["InternationalOut", option_type(bool_type)]]);
}

export class DatapackageState extends Record {
    constructor(LimitInMb, RemainingInMb, RolloverInMb) {
        super();
        this.LimitInMb = LimitInMb;
        this.RemainingInMb = RemainingInMb;
        this.RolloverInMb = RolloverInMb;
    }
}

export function DatapackageState$reflection() {
    return record_type("Containers.SimpleOrder.Model.DatapackageState", [], DatapackageState, () => [["LimitInMb", option_type(int32_type)], ["RemainingInMb", option_type(int32_type)], ["RolloverInMb", option_type(int32_type)]]);
}

export class TopupState extends Record {
    constructor(LimitInMb, RemainingInMb) {
        super();
        this.LimitInMb = LimitInMb;
        this.RemainingInMb = RemainingInMb;
    }
}

export function TopupState$reflection() {
    return record_type("Containers.SimpleOrder.Model.TopupState", [], TopupState, () => [["LimitInMb", option_type(int32_type)], ["RemainingInMb", option_type(int32_type)]]);
}

export class DatapoolState extends Record {
    constructor(PoolId, Members) {
        super();
        this.PoolId = PoolId;
        this.Members = Members;
    }
}

export function DatapoolState$reflection() {
    return record_type("Containers.SimpleOrder.Model.DatapoolState", [], DatapoolState, () => [["PoolId", option_type(string_type)], ["Members", option_type(list_type(string_type))]]);
}

export class NumberState extends Record {
    constructor(CommonService, Roaming, General, Barring, ReadOnlyDatapackage, ReadOnlyTopup, ReadOnlyDatapool) {
        super();
        this.CommonService = CommonService;
        this.Roaming = Roaming;
        this.General = General;
        this.Barring = Barring;
        this.ReadOnlyDatapackage = ReadOnlyDatapackage;
        this.ReadOnlyTopup = ReadOnlyTopup;
        this.ReadOnlyDatapool = ReadOnlyDatapool;
    }
}

export function NumberState$reflection() {
    return record_type("Containers.SimpleOrder.Model.NumberState", [], NumberState, () => [["CommonService", option_type(CommonServiceState$reflection())], ["Roaming", option_type(RoamingState$reflection())], ["General", option_type(GeneralState$reflection())], ["Barring", option_type(BarringStatus$reflection())], ["ReadOnlyDatapackage", option_type(DatapackageState$reflection())], ["ReadOnlyTopup", option_type(TopupState$reflection())], ["ReadOnlyDatapool", option_type(DatapoolState$reflection())]]);
}

